<template>
  <v-card>
    <v-img
      class="previewImage"
      :src="imageUrl"
      :aspect-ratio="16 / 9"
      width="100%"
    >
      <div class="mealTitle">{{ item.name }}</div>
    </v-img>
    <v-row>
      <v-col sm="6">
        <v-chip class="ma-2" :color="kategorieFarbe()">{{
          item.kategorie
        }}</v-chip>
      </v-col>
      <v-col sm="6" class="text-right">
        <div class="ma-2">Preis: € {{ currencyFormat(item.preis) }}</div>
      </v-col>
    </v-row>
    <v-row v-if="item.grossgebinde">
      <v-col>
        <v-chip class="ma-2">Großgebinde</v-chip>
      </v-col>
    </v-row>
    <div class="pa-2 mealDesc">{{ item.beschreibung }}</div>
    <div class="pa-2">Allergene: {{ item.allergene }}</div>
    <v-row class="pa-2">
      <v-col>
        <v-rating
          empty-icon="mdi-chef-hat"
          full-icon="mdi-chef-hat"
          readonly
          background-color="grey darken-1"
          color="green"
          length="5"
          small
          :value="3"
        ></v-rating>
      </v-col>
      <v-col class="text-right">
        <v-icon class="editButton ma-1" color="green" @click="editItem()"
          >mdi-pencil</v-icon
        >
        <v-icon class="deleteButton ma-1" color="red" @click="removeMeal()"
          >mdi-delete</v-icon
        >
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({}),
  methods: {
    removeMeal() {
      this.$emit("deleteItem", this.item);
    },
    editItem() {
      this.$emit("editItem", this.item);
    },
    kategorieFarbe() {
      if (this.item.kategorie == "Vorspeisen") {
        return "red lighten-2";
      } else if (this.item.kategorie == "Hauptspeisen") {
        return "green lighten-2";
      } else if (this.item.kategorie == "Desserts") {
        return "orange lighten-2";
      }
    },
    currencyFormat(value = 0) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  },
  computed: {
    imageUrl() {
      if (!this.item.bilder || this.item.bilder.length == 0) {
        if (this.item.kategorie == "Vorspeisen")
          return require("@/assets/vorspeise.jpg");
        else if (this.item.kategorie == "Hauptspeisen")
          return require("@/assets/hauptspeise.jpg");
        else if (this.item.kategorie == "Desserts")
          return require("@/assets/dessert.jpg");
        else return require("@/assets/bg1.jpg");
      }

      return this.item.bilder[0];
    }
  },

  mounted() {}
};
</script>

<style scoped>
.previewImage {
  max-height: 150px;
  height: 150px;
}

.deleteButton {
  padding: 3px;
  border-radius: 50%;
}
.editButton {
  padding: 3px;
  border-radius: 50%;
}
.editButton:hover,
.deleteButton:hover {
  background-color: rgba(122, 122, 122, 0.226);
}

.mealTitle {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 4px;
  opacity: 1;
}

.mealDesc {
  font-size: 14px;
}
</style>
